import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { Footer } from "src/molecules/Footer";
import { Header } from "src/organisms/Header";
import { setGender } from "src/modules/page";
import { Modal } from "src/atoms/Modal";
import { ScreenLoader } from "src/molecules/ScreenLoader";
import { useRouter } from "next/router";

export default function LoginPages({
  children,
}: {
  children: JSX.Element;
}): JSX.Element {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setGender("women"));
  }, [dispatch]);

  const router = useRouter();
  const { query } = router;
  const openScreenLoader = query.signin;

  return (
    <div>
      {openScreenLoader === "true" && (
        <Modal onClose={() => {}} overFlow={"visible"} isOpen={true}>
          <ScreenLoader />
        </Modal>
      )}
      <Header isLoginFlow />
      {children}
      <Footer />
    </div>
  );
}
